import axios from '../../../../utils/AxiosUtils';
import i18n from '../../../../i18next';

import {
    LOADING,
    LOAD_DINEIN_SETTINGS_SUCCESS,
    UPDATE_DINEIN_SETTINGS_SUCCESS,
    RESET_DINEIN_SETTINGS
} from '../../../types';
import MessageUtils from "../../../../utils/MessageUtils";
import { doLoadOpeningHours } from '../../../index';

export const loadDineInSettings = (restaurantId) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/settings/${restaurantId}/dine-in`;

        axios().get(url)
            .then(response => loadDineInSettingsSuccess(dispatch, response, getState, restaurantId))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:deliveryActions.loadSettingsFailure')));
    }
}

const loadDineInSettingsSuccess = (dispatch, response, getState, restaurantId) => {
    if (response.status === 204) {
        const saveDataToScreen = 'dinein';
        doLoadOpeningHours(restaurantId, dispatch, getState, saveDataToScreen);
    }

    dispatch({ type: LOADING, payload: false });

    if (response.status !== 204) {
        dispatch({ type: LOAD_DINEIN_SETTINGS_SUCCESS, payload: response.data });
    }
}

export const updateDineInSettings = (restaurantId, state, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/settings/${restaurantId}/dine-in`;

        const dineInSettings = {
            id: state.id,
            preparationTimes: state.preparationTimes,
            supportedTenderTypes: state.supportedTenderTypes,
            minimumOrderAmount:
                state.minimumOrderAmount === undefined || state.minimumOrderAmount === null || state.minimumOrderAmount === '' ?
                    1 : Number(state.minimumOrderAmount),
            maximumOrderAmount:
                state.maximumOrderAmount === undefined || state.maximumOrderAmount === null || state.maximumOrderAmount === '' ?
                    null : Number(state.maximumOrderAmount),
            timeSlots: state.timeSlots,
            nextDayOrdersOnly: state.nextDayOrdersOnly,
            nextDayOrdersNumber: state.nextDayOrdersNumber
        }

        axios().post(url, dineInSettings)
            .then(response => updateDineInSettingsSuccess(dispatch, response, callback))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.saveFailure')));
    }
}

const updateDineInSettingsSuccess = (dispatch, response, callback) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: UPDATE_DINEIN_SETTINGS_SUCCESS, payload: response.data });
    if (callback) {
        callback();
    }
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.saveSuccess'));
}

export const resetDineInSettings = () => {
    return (dispatch) => {
        dispatch({ type: RESET_DINEIN_SETTINGS });
    }
};


// WEBPACK FOOTER //
// ./src/actions/restaurants/settings/service/DineInActions.js